import {
  Button,
  ButtonGroup,
  ButtonProps,
  Center,
  Flex,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { ReactNode, RefObject, useState } from 'react';

export type ButtonWithConfirmTooltipProps = ButtonProps & {
  children: ReactNode;
  confirmTitle?: string | ReactNode;
  confirmMessage?: string | ReactNode;
  confirmButtonVariant?: string;
  onClickConfirm: () => Promise<any>;
  containerRef?: RefObject<HTMLElement> | null;
};

export default function ButtonWithConfirmTooltip({
  children,
  confirmTitle = "Supprimer l'élément",
  confirmMessage = "Êtes-vous sûr de vouloir supprimer l'élément ?",
  confirmButtonVariant = 'brand',
  onClickConfirm,
  containerRef = null,
  ...props
}: ButtonWithConfirmTooltipProps) {
  const [confirming, setConfirming] = useState(false);
  const { isOpen, onToggle, onClose } = useDisclosure();

  return (
    <Popover isOpen={isOpen} onClose={onClose} closeOnBlur={false}>
      <PopoverTrigger>
        <Button onClick={onToggle} {...props} variant={props.variant}>
          {children}
        </Button>
      </PopoverTrigger>
      <Portal containerRef={containerRef}>
        <PopoverContent borderRadius="0" borderBottomRightRadius="1.875rem">
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader color="brand.100" fontWeight="600">
            {confirmTitle}
          </PopoverHeader>
          <PopoverBody>
            <Flex direction="column" gap="1rem">
              <Text>{confirmMessage}</Text>
              <Center>
                <ButtonGroup size="xs">
                  <Button variant={'outline'} onClick={onClose} width="5rem">
                    Non
                  </Button>
                  <Button
                    width="5rem"
                    variant={confirmButtonVariant}
                    isLoading={confirming}
                    isDisabled={confirming}
                    cursor={confirming ? 'not-allowed' : 'pointer'}
                    onClick={async () => {
                      setConfirming(true);
                      await onClickConfirm();
                      setConfirming(false);
                      onClose();
                    }}
                  >
                    Oui
                  </Button>
                </ButtonGroup>
              </Center>
            </Flex>
          </PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  );
}
